module.exports = __webpack_public_path__ + "static/media/image_25.ee38cfd6.png";